// A read-only view (round 3 of the customer page's critique, support B1): Paige staff looking at a
// company under a read-only support grant. The API refuses every write with 403
// `support_grant_read_only`; the workbench says so before the click, takes no review lease, and
// leaves the controls that would write disabled with this hover text.

/** The hover text on a control a read-only view disables. */
export const READ_ONLY_HINT = 'Read-only view';

/** Whether Paige mounted the workbench for a read-only view (the bridge's `readOnly`). */
export function readOnlyView(): boolean {
  return window.paigeWorkbench?.readOnly === true;
}
